export const sortOrderRowsByKey = (orderRows, field, direction = 'desc') => {
    return [...orderRows].sort((a, b) => {
        const valueA = a[field] ?? '';
        const valueB = b[field] ?? '';
        const comparison = valueA > valueB ? 1 : -1;
        return direction === 'desc' ? -comparison : comparison;
    });
};
